import { Phone, Mail, MapPin } from "lucide-react";
import { trackContact } from "../lib/track";

const AREAS = [
  "Sydney CBD", "Bondi", "Manly", "Parramatta", "Mascot Airport",
  "North Shore", "Inner West", "Eastern Suburbs",
];

const CONTACT_PHONE = "1300 582 485";
const CONTACT_TEL = "1300582485";
const CONTACT_EMAIL = "sydneyasaptaxis@gmail.com";

export const Footer = () => (
  <footer id="contact" className="relative border-t border-gold-400/15 bg-ink-950">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
      <div className="grid lg:grid-cols-[1.2fr_0.8fr_0.8fr] gap-12 mb-16">
        <div>
          <a href="#top" className="font-display font-extrabold tracking-wide text-lg text-white">
            SYDNEY <span className="text-gold-400">ASAP</span> TAXIS
          </a>
          <p className="mt-5 text-sm leading-relaxed text-[#99A1B3] max-w-md">
            Need a taxi ASAP? Book a local taxi near you instantly online — or call{" "}
            {CONTACT_PHONE}. Sydney ASAP Taxis is the reliable Sydney taxi service for airport transfers, CBD rides and late-night pickups
            across every Sydney suburb. Fixed meter rates, zero surge pricing, 24/7 dispatch.
            Cabcharge, TTSS e-ticket cards and taxi vouchers accepted on every ride.
          </p>
          <div className="mt-7 flex flex-wrap gap-4">
            <a
              href="#book"
              data-testid="footer-book-button"
              className="rounded-full bg-gold-400 text-ink font-bold px-6 py-3 text-sm hover:bg-gold-300 transition-colors duration-200"
            >
              Book a Taxi Now
            </a>
            <a
              href={`tel:${CONTACT_TEL}`}
              onClick={trackContact}
              data-testid="footer-call-button"
              className="rounded-full border border-gold-400/40 text-gold-300 font-semibold px-6 py-3 text-sm hover:bg-gold-400/10 transition-colors duration-200"
            >
              Call {CONTACT_PHONE}
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-gold-400 mb-5">Contact</h3>
          <ul className="space-y-4 text-sm text-[#99A1B3]">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-gold-400 shrink-0 mt-0.5" />
              <span>{CONTACT_PHONE}<br /><span className="text-[#626B7F]">24/7 dispatch</span></span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-gold-400 shrink-0 mt-0.5" />
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                data-testid="footer-email-link"
                className="hover:text-white transition-colors break-all"
              >
                {CONTACT_EMAIL}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-gold-400 shrink-0 mt-0.5" />
              <span>Sydney, NSW, Australia<br /><span className="text-[#626B7F]">Serving all metro suburbs</span></span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-gold-400 mb-5">Service areas</h3>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm text-[#99A1B3]">
            {AREAS.map((a) => (
              <li key={a} className="flex items-center gap-2">
                <span className="h-1 w-1 rounded-full bg-gold-400" aria-hidden="true" /> {a}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-gold-400/10 pt-8 mb-6 text-xs leading-relaxed text-[#626B7F]" data-testid="legal-disclaimer">
        <p className="max-w-3xl">
          <span className="text-[#99A1B3] font-semibold">Disclaimer:</span> Sydney ASAP Taxis is an
          independently owned and operated taxi booking service registered in NSW, Australia. We are
          not affiliated with, endorsed by, or in any way officially connected with 13Cabs, Silver
          Service, Silvertop Taxis, or any other taxi brands, networks or registered trademarks.
          All trademarks and brand names are the property of their respective owners.
        </p>
      </div>

      <div className="border-t border-gold-400/10 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[#626B7F]">
        <p>© {new Date().getFullYear()} Sydney ASAP Taxis — Reliable Sydney taxi service. Taxi near me, taxi ASAP, book a taxi now.</p>
        <p className="flex items-center gap-4">
          <a href="/privacy.html" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</a>
          <a href="/terms.html" data-testid="footer-terms-link" className="hover:text-white transition-colors">Terms &amp; Conditions</a>
          <span className="font-mono">SYDNEY · NSW · AU</span>
        </p>
      </div>
    </div>
  </footer>
);
